import { render } from "./bet-history.vue?vue&type=template&id=89ee7222&scoped=true&ts=true"
import script from "./bet-history.vue?vue&type=script&lang=ts"
export * from "./bet-history.vue?vue&type=script&lang=ts"

import "./bet-history.vue?vue&type=style&index=0&id=89ee7222&lang=scss&scoped=true"

import exportComponent from "D:\\project\\fantan\\h5\\fantan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89ee7222"]])

export default __exports__